import Grid from '@material-ui/core/Grid';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardSubtitle, CardText } from 'reactstrap';

import styles from '../styles.css';

class RoutesStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { routes, date, period } = this.props;
		const totalPackages = routes.reduce(
			(acc, route) => acc + route.number_of_packages,
			0
		);
		return (
			<Card className="shadow border-0">
				<CardBody>
					<h3 className="card-title">{`${routes.length} Rotas`}</h3>
					<CardSubtitle>{`${moment(date).format('dddd [,] ll')} - ${period &&
						period.name}`}</CardSubtitle>
					<CardText>
						<Grid container direction="row" spacing={24}>
							<Grid item>
								<ShoppingBasket className={styles.icon} />
								<span>
									{`Total de pedidos: `} <strong>{totalPackages}</strong>
								</span>
							</Grid>
						</Grid>
					</CardText>
				</CardBody>
				<div className="card-mt-footer" />
			</Card>
		);
	}
}

RoutesStatus.propTypes = {
	routes: PropTypes.arrayOf(
		PropTypes.shape({
			number: PropTypes.number,
			delivery_eta: PropTypes.number,
			estimated_price: PropTypes.number,
			status: PropTypes.string,
		})
	),
	date: PropTypes.string,
	period: PropTypes.shape({
		name: PropTypes.string,
	}).isRequired,
};

RoutesStatus.defaultProps = {
	routes: [],
	date: null,
};

export default RoutesStatus;
